import ObjectFitClass from '../utils/_object-fit'

export default function ObjectFit () {
    new ObjectFitClass()
}